/**
 * All feature flag keys and their default values.
 * Add new flags here — the key must match the flag key in LaunchDarkly.
 */
export const FLAG_DEFAULTS = {
  oauth_providers: [] as string[],
  stripe_enabled: false,
  'enable-plan-to-ride': false,
  'enable-comments': false,
  'enable-blog': false,
  'advanced-filters': false,
  'enable-home-feed': false,
} as const;

export type FeatureFlags = {
  [K in keyof typeof FLAG_DEFAULTS]: (typeof FLAG_DEFAULTS)[K];
};
